import React from 'react';
import './timetable.scss';
import {Logout,SevenDaysFormatted, TodayFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Format,
  Column,
  Button,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Lookup,
  Popup,
  Form,
  Editing,
  Selection,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel,
  Toolbar
  //Item
} from 'devextreme-react/data-grid';

import { useState, useEffect, useCallback} from "react";

import { CheckBox } from 'devextreme-react/check-box';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

import { confirm } from 'devextreme/ui/dialog';
import {Button as ToolbarButton} from 'devextreme-react/button';
import { Item } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';

import { formatNumber } from 'devextreme/localization';

const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Movimenti';

const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Movimento';


//export default function SupplierDue(props) {
export default function SupplierDue({ commessaFilter, intermediarioFilter },props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;
  const initIntermediario = isInProject? 0:210;
  const initCommessa = isInProject? projectId:0;

    var dueSupplierDataGridRef = React.createRef();

    const [commesse, setCommesse] = useState({});
    const [intermediari, setIntermediari] = useState({});
    const [categorie, setCategorie] = useState({});
    const [modalitaPagam, setModalitaPagam] = useState({});

    const [currentRow, setCurrentRow] = useState(1);
    const [isRowSelected, setIsRowSelected] = useState(false);

    //const [intermediarioFilter, setIntermediarioFilter] = useState(initIntermediario);
    //const [commessaFilter, setCommessaFilter] = useState(initCommessa);

    const editorOptions = { readonly: true, format: '#,##0.00'};
    const [escludiFattureFilter, setEscludiFattureFilter] = useState(true);

    const { user } = useAuth(); 

    if (!user) 
      Logout();

    const filterPayload = { 
        commessa: commessaFilter,
        intermediario: intermediarioFilter,
        escludiMovimentiFatture: escludiFattureFilter
    };


    const remoteDataSourceDue = createStore({
        key: 'id',
        loadUrl: serviceUrl2 + '/FindPagamenti',
      
        onBeforeSend: (method, ajaxOptions) => {
          if (method === "load" ) {           
              var payload = ajaxOptions.data;
              payload.values = JSON.stringify(filterPayload);
              ajaxOptions.data = payload;          
          }  
          ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
         ;
        },
        //loadUrl: serviceUrl2 + '/GetAction',
        insertUrl: serviceUrl4 + '/InsertAction',
        updateUrl:serviceUrl4 + '/UpdateAction',
        deleteUrl: serviceUrl4 + '/DeleteAction'  
    });

    useEffect(() => {
      if (dueSupplierDataGridRef?.instance) {
        dueSupplierDataGridRef.instance().refresh();
      }
    }, [commessaFilter, intermediarioFilter]);

    useEffect(() => {
  
        const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
        var newUrl1 =  newServiceUrl1 + "/GetOpen";
    
        const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
        var newUrl5 =  newServiceUrl5 + "/GetAction";
    
        const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
        var newUrl7 =  newServiceUrl7 + "/GetIntermediari";
    
        const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CategoriaAnalitica';
        var newUrl12 =  newServiceUrl12 + "/GetAction";

        const fetchData = async () => {
          try {

            const requestOptions = {
              headers: {
                Authorization: `Bearer ${user.token}`
              }
            };

            const response1 = await fetch(newUrl1,requestOptions);
            const json1 = await response1.json();
            //console.log(json1);
            setCommesse(json1);
    
            const response5 = await fetch(newUrl5);
            const json5 = await response5.json();
            //console.log(json5);
            setModalitaPagam(json5);
    
            const response7 = await fetch(newUrl7,requestOptions);
            const json7 = await response7.json();
            console.log(json7);
            setIntermediari(json7);

            const response12 = await fetch(newUrl12);
            const json12 = await response12.json();
            console.log(json12);
            setCategorie(json12);
    
          } catch (error) {
            console.log("error", error);
          }
        };
        fetchData();
      }, []);

  function duplicateMov(e) {
    let result = confirm("<i>Procedere con la duplicazione del movimento?</i>", "Duplicazione Movimento");
    result.then((dialogResult) => {
      if  (dialogResult) {
        duplica(currentRow);
      }  
    });
  }
    
  const duplica= (idMovimento) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Movimento/Duplicate/' + idMovimento;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        dueSupplierDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

const onCellPreparedDue = (e) => {

    if (e.rowType === "data") {

      if (e.column.dataField === "dataScadenza" || e.column.dataField === "giorniScadenza") 
      {
        var dataScadenza = e.data.dataScadenza;
        var dataPagamento = e.data.dataPagamento;
        //console.log("SCADENZA: " + dataScadenza);
        //console.log("OGGI: " + todayFormatted());
        if ((dataPagamento !== null))
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: lightgreen; text-align: right;font-weight: bold";
          else
          e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
        }

        else if (dataScadenza < TodayFormatted()) 
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: red; text-align: right; font-weight: bold";
          else
            e.cellElement.style.cssText = "color: red; font-weight: bold";
        }

        else if ((dataScadenza < SevenDaysFormatted()) &&  (dataScadenza > TodayFormatted()) )
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: orange; text-align: right; font-weight: bold";
          else
            e.cellElement.style.cssText = "color: orange; font-weight: bold";
        }
          
      }
    }
  }

  function onToolbarPreparing(e) {
  
    e.toolbarOptions.items.push({
      widget: 'dxButton',
      name: "myexport",
      location: "before",
      options: {
        icon: "exportxlsx",
        hint: "Esporta in Excel",
        onClick: function() {
          onExporting(e);
        }
      }
    });
    
  }

  function onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Pagamenti');
    
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Pagamenti.xlsx');
        });
      });
      e.cancel = true;
  }

  function onRowSelectionChanged({ selectedRowsData }) {
      const data = selectedRowsData[0];
      if (data !== null && data !== undefined) {
        setCurrentRow(data.id);
        setIsRowSelected(true);
        
      } else{
        setIsRowSelected(false);
      }
      
  }

  function blockMov(e) {
    blocca(currentRow);
  };
    
  function unBlockMov(e) {
    sblocca(currentRow);
  };
    
  const blocca= (idMovimento) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Movimento/Block/' + idMovimento;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
      
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        dueSupplierDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }
    
  const sblocca= (idMovimento) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Movimento/UnBlock/' + idMovimento;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        dueSupplierDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const hideEditButton = useCallback((e) => {
    return e.row.data.statoId !== 1;
  }, []);
    
  async function setDueValues(newData, value, currentRowData) {
    newData.importoParziale = value;
    newData.saldo = currentRowData.importoTotale - currentRowData.importoResiduo - value;
  };

  function onCheckValueChanged(e)  {
    setEscludiFattureFilter(e.value);
  };

  function customizeData(data) {
    return `Totale: ${formatNumber(data.value, '###,##0.00')}`;
  }

    return (
        <DataGrid
            dataSource={remoteDataSourceDue}
            focusedRowEnabled={true}
            onCellPrepared={onCellPreparedDue}
            onSelectionChanged={onRowSelectionChanged}
            onExporting={onExporting}
            onToolbarPreparing = {onToolbarPreparing}
            dateSerializationFormat= {'yyyy-MM-dd'}
            ref={ref => dueSupplierDataGridRef = ref}
        >

        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <HeaderFilter visible={true} />
        <Selection mode="single" />
        <Toolbar>
 
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='copy'
              hint='Duplica'
              onClick={duplicateMov} 
              disabled={!isRowSelected}
            />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='key'
              hint='Blocca'
              onClick={blockMov} 
              disabled={!isRowSelected}
            />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Sblocca'
              onClick={unBlockMov} 
              disabled={!isRowSelected}
            />
          </Item>
          <Item location="after">
            <CheckBox  
              value={escludiFattureFilter} onValueChanged={onCheckValueChanged}
              defaultValue={escludiFattureFilter}
              text="  Escludi mov. fatture   "
            >
            </CheckBox>
          </Item> 

          <Item name="searchPanel" className="offer-toolbar"/>
        
        </Toolbar>
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        >

        

        <Popup   title= "&nbsp;&nbsp;&nbsp;Scadenza " showTitle={true} width={800} height={625} />
         
        <Form>
            <Item itemType="group" caption="" colCount={2} colSpan={2}>
            
                <Item dataField="commessaId" colSpan={2} />
                <Item dataField="numeroOrdineFornitore" />  
        
                <Item dataField="soggetto" /> 
                <Item dataField="descrizione" colSpan={2} />
                <Item dataField="dataScadenza"/>
                <Item dataField="giorniScadenza"/>
                <Item dataField="importoTotale" editorOptions={editorOptions}/>
                <Item dataField="importoRata" editorOptions={editorOptions}/>
                <Item dataField="importoResiduo" editorOptions={editorOptions}/>
                <Item dataField="saldo" editorOptions={editorOptions}/>
                <Item dataField="importoParziale" editorOptions={editorOptions}/>
                <Item itemType="empty"/>
                
                <Item dataField="dataPagamento" editorType="dxDateBox" /> 
                <Item dataField="modalitaPagamentoId" editorType="dxSelectBox" />  
                <Item dataField="riferimentoFattura"/>
                <Item itemType="empty"/>
                <Item dataField="categoriaAnaliticaId" editorType="dxSelectBox" /> 
                <Item itemType="empty"/> 
                <Item dataField="note" colSpan={2} editorType="dxTextArea" />
            
          
            </Item> 
          </Form>
        </Editing>
        <Column dataField="id" caption="#" visible={false}/>
        <Column dataField="commessaId" caption="Commessa" width={100} groupIndex={0} allowEditing={false}>
          <Lookup dataSource={commesse} displayExpr="nomeEsteso" valueExpr="id" />
        </Column>
        <Column dataField="refId" caption="#" width={40} allowHeaderFiltering={true} allowEditing={false}/>
        <Column dataField="rata" caption="Rata" width={60} allowEditing={false}/>
        <Column dataField="numeroOrdineFornitore" caption="Ordine" width={100} allowEditing={false}/>
        <Column dataField="soggetto" caption="Fornitore" allowEditing={false}/>
        <Column dataField="descrizione" width={400} allowHeaderFiltering={false} allowEditing={false}/>
        <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true} allowEditing={true}/>
        <Column dataField="giorniScadenza" caption="Giorni" width={60} allowHeaderFiltering={false} allowEditing={false}/>
        <Column dataField="importoTotale" allowHeaderFiltering={false} caption="Importo Totale" allowEditing={false} visible={false}>
          <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
        </Column>
        <Column dataField="importoRata" visible={true} allowHeaderFiltering={false} caption="Importo" allowEditing={false} >
          <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
        </Column>
        <Column dataField="importoParziale"  caption="Importo Pagato" allowHeaderFiltering={false} setCellValue={setDueValues}>
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="importoResiduo" visible={false} allowEditing={false} caption="Totale già pagato">
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="saldo" allowHeaderFiltering={false} allowEditing={false}>
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="dataPagamento" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true}/>
        <Column dataField="modalitaPagamentoId" caption="Modalità Pagamento" width={100} visible={false}>
          <Lookup dataSource={modalitaPagam} displayExpr="descrizione" valueExpr="id" />
        </Column>
        <Column dataField="categoriaAnaliticaId" caption="Categoria" width={100} visible={false}>
          <Lookup dataSource={categorie} displayExpr="descrizione" valueExpr="id" />
        </Column>
        <Column dataField="riferimentoFattura" caption="Rif. Fattura" visible={false}/>
        <Column type="buttons">
          <Button name="edit" visible={hideEditButton} />
          <Button name="delete" visible={hideEditButton}/>
        </Column>

        <Summary>
          <GroupItem
            column="importoRata"
            summaryType="sum"
            customizeText={customizeData}
            showInGroupFooter
          />
        </Summary>
    </DataGrid>
    )
}